import moment from "moment";

export function dateFormat(date: string, format: string = "DD.MM.YYYY, HH:mm"): string {
    return moment(date).format(format);
}